<svelte:options accessors />

<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { getComponent } from "./index";
  import { type ShopComponentProps } from "./types";

  export let type: string;
  export let componentProps: ShopComponentProps;

  const dispatch = createEventDispatcher();

  const components = getComponent(type);

  if (!components) {
    console.error(`Component <${type}> not found`);
  }

  const { AdapterComponent, Component } = components!;

  // typescript doesn't understand that the Component is the right one for our AdapterComponent
  const ThisIsTheCorrectComponentIPromise = Component as any;
</script>

{#if AdapterComponent}
  <svelte:component
    this={AdapterComponent}
    Component={ThisIsTheCorrectComponentIPromise}
    {dispatch}
    {componentProps}
  />
{/if}
